import {
    Component,
    Input, OnDestroy,
    OnInit,
} from '@angular/core';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';
import {UserNamespace} from '@namespaces/user.namespace';
import {EventsService} from '@services/events.service';
import {TechnicalDeviceTechnicalCardApiService} from '@api/technical-device-technical-card.api.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {TechnicalDeviceElementsGroupApiService} from '@api/technical-device-elements-group.api.service';
import {RoutesStorage} from '@helpers/routes.helper';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-elements-group-list-item',
    templateUrl: 'elements-group-list-item.component.html',
    styleUrls: ['elements-group-list-item.component.scss'],
})

export class ElementsGroupListItemComponent implements OnInit, OnDestroy {
    @Input() elementGroup: TechnicalDeviceNamespace.ElementGroupInterface;

    @Input() isFetching = false;

    public permissions = UserNamespace.Permission;

    public editUrl: string;

    constructor(
        private techcardApi: TechnicalDeviceTechnicalCardApiService,
        private elementsGroupsApi: TechnicalDeviceElementsGroupApiService,
        private events: EventsService,
        private dataService: TechnicalDeviceDataService,
    ) {
    }

    ngOnInit() {
        this.editUrl = RoutesStorage.ElementGroup.edit(this.elementGroup.id);
    }

    onTechcardRemoveClick(item?: TechnicalDeviceNamespace.ElementGroupTechcardInterface) {
        if (!item) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить техкарту?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.techcardApi.get({
                url: this.techcardApi.getRemoveDocumentPath(item.id)
            }).pipe(
                untilDestroyed(this)
            ).toPromise().then((id: number) => {
                this.dataService.technicalCardRemoved$.next();
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.technicalDeviceTechnicalCardRemovedMessage,
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.technicalDeviceTechnicalCardRemovedFailMessage,
                });
            });
        }, () => {});
    }

    onRemoveClick() {
        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить типоразмер?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.elementsGroupsApi.delete({
                id: this.elementGroup.id
            }).pipe(
                untilDestroyed(this)
            ).toPromise().then((id: number) => {
                this.dataService.elementGroupRemoved$.next();
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.technicalDeviceElementGroupRemovedMessage,
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.technicalDeviceElementGroupRemovedFailMessage,
                });
            });
        }, () => {});
    }

    ngOnDestroy() {

    }
}
